import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Permission.module.css";
import { SearchInput, TextComponent } from "../../../../components";
import { useDispatch } from "react-redux";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { List } from "antd";
import dummyImg from "../../../../assets/dummy.jpg";
import Dropdown from "../../../../components/dropdowns/Dropdown";
import PermissionCard from "./PermissionCard";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
const Permission = () => {
  const {
    state: { event_id },
  } = useLocation();
  const dispatch = useDispatch();
  const [list, setlist] = useState([]);
  const [search, setSearch] = useState(null);
  // console.log("list???????", list);
  const ref = useRef();

  useEffect(() => {
    dispatch(EventMiddleware.getEventGuest({ event_id, search: "" }))
      .then((data) => {
        setlist(data);
      })
      .catch();
  }, []);
  const ChangeRole = (user_id, role, index) => {
    dispatch(AuthMiddleware.UpdateRole({ user_id, role }))
      .then(() => {
        let data = [...list];
        data[index].role = role;
        setlist(data);
      })
      .catch();
  };
  const onSearch = (e) => {
    setSearch(e);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      console.log("innnnnnnn", e);
      dispatch(EventMiddleware.getEventGuest({ event_id, search: e }))
        .then((data) => {
          setlist(data);
        })
        .catch();
    }, 1500);
  };
  return (
    <div className={styles.mainCon}>
      <div className={styles.searchInput}>
        <SearchInput
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={"Search Guest"}
        />
      </div>
      <List
        dataSource={list}
        className={styles.list}
        renderItem={(item, index) => {
          return (
            <div className={styles.listItem}>
              <div className={styles.leftElement}>
                <img src={item?.image ? item?.image : dummyImg} />
                <TextComponent
                  text={item?.name ? item?.name : "--"}
                  textClass={styles.name}
                />
              </div>
              <div className={styles.parRight}>
                <div className={styles.dropdown}>
                  <PermissionCard
                    i={index}
                    length={list?.length}
                    role={item?.role}
                    onChangestate={(val) =>
                      ChangeRole(item?.id, val?.val?.toLowerCase(), index)
                    }
                  />
                </div>
                <div className={styles.rightElement}>
                  <TextComponent
                    text={item?.role ? item?.role : "--"}
                    textClass={
                      item?.role == "guest" ? styles.name : styles.CHname
                    }
                  />
                </div>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default Permission;
